require('./openYoungCardCancelChoresView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ actions
const openYoungCardChoreStatusUpdate = require('actions/openYoungCardChoreStatusUpdate');
const openYoungCardChores = require('actions/openYoungCardChores');

// @ components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CancelChore = require('./components/CancelChoreConfirmation');
const { OKCover } = require('commonsComponents/OKCover');

// @ Utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;

class CancelChoresView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { match: { params: { choreAssignmentId } }, getChoreDetail } = this.props;
        getChoreDetail( choreAssignmentId );
    }

    componentWillUnmount() {
        this.props.openYoungChoreResetStatusUpdateInfo();
    }


    buildHeader() {
        const {
            immCards,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias','current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-openYoungChores'),
                url: `/myprofile/cards/${cardId}/chores`
            },
            {
                text: formatText('breadcrumb-openYoungCancelChores')
            }
        ];

        return (
            <OKCover size="medium" section="transfers">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('cancelChore-headerTitle')} />
            </OKCover>
        );
    }

    render() {
        const {
            immCards,
            openYoungCardChoreStatusUpdateInfo,
            openYoungCardChores,
            match,
            updateChoreStatus
        } = this.props;

        if(openYoungCardChores.get('getChoreDetailFetch')) {
            return <LoadingSection />;
        }else {
            return (
                <section>
                    <div>
                        {this.buildHeader()}
                    </div>
                    <div className="cancel-chore-view__content">
                        <div className="row">
                            <div className="col-xs-12 col-md-8 col-md-offset-2">
                                <CancelChore
                                    immCards={immCards}
                                    openYoungCardChores={openYoungCardChores}
                                    openYoungCardChoreStatusUpdateInfo={openYoungCardChoreStatusUpdateInfo}
                                    updateChoreStatus={updateChoreStatus}
                                    match={match}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    }
}

CancelChoresView.propTypes = {
    getChoreDetail: PropTypes.func.isRequired,
    immCards: PropTypes.object,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object,
    openYoungCardChores: PropTypes.object.isRequired,
    openYoungChoreResetStatusUpdateInfo: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    updateChoreStatus: PropTypes.func.isRequired
};

module.exports.constructor = CancelChoresView;
module.exports.CancelChoresView = connect(
    state => ({
        immCards: state.cards,
        openYoungCardChores: state.openYoungCardChores,
        openYoungCardChoreStatusUpdateInfo: state.openYoungCardChoreStatusUpdateInfo
    }),
    {
        getChoreDetail: openYoungCardChores.getChoreDetail,
        openYoungChoreResetStatusUpdateInfo: openYoungCardChoreStatusUpdate.openYoungChoreResetStatusUpdateInfo,
        updateChoreStatus: openYoungCardChoreStatusUpdate.updateChoreStatus
    })(CancelChoresView);
